import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

/** 已安装终端项 */
export interface InstalledTerminalItem {
  /** 计算机名 */
  computer_name: string
  /** 外网ip */
  client_ip?: string
  /** 分组名 */
  group_name?: string
  /** Mac地址 */
  mac?: string
  /** 内网ip,以"，"分隔 */
  system_ip?: string
  /** 操作系统 */
  system_name?: string
  /** 登记用户名 */
  user_mark?: string
}

/** 已安装终端列表请求 */
export interface InstalledTerminalListReq {
  /** 子网地址开始 */
  subnet_address_start: string
  keyword?: string
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 子网地址结束 */
  subnet_address_end?: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type?: number
  group_id?: number
}

/** 已安装终端列表响应 */
export interface InstalledTerminalListRes {
  list?: InstalledTerminalItem[]
  total?: number
}

@Injectable()
export class InstalledTerminalDrawerService {
  constructor (private http: Http) {
  }

  /** 获取已安装终端列表 */
  @ParamsClean()
  @InvokeThrottle()
  getInstalledTerminalList (data: InstalledTerminalListReq) {
    data.system_type ||= undefined
    return this.http.post<InstalledTerminalListRes>('/client_find/install_list', data)
  }

  /** 导出已安装终端列表 */
  downloadInstalledTerminalList (type: 0 | 1, options: InstalledTerminalListReq, moduleName: string) {
    const params = {
      ...options,
      file_type:type,
      limit: 0,
      page: 0
    }
    params.system_type ||= undefined
    return this.http.downloadWithBlob('/client_find/install_list_export', params, moduleName)
  }
}

